import { render, staticRenderFns } from "./duoTraining.vue?vue&type=template&id=721ec6fe&scoped=true&"
import script from "./duoTraining.vue?vue&type=script&lang=js&"
export * from "./duoTraining.vue?vue&type=script&lang=js&"
import style0 from "./duoTraining.vue?vue&type=style&index=0&id=721ec6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ec6fe",
  null
  
)

export default component.exports